import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/GridFour.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: i }));
r.displayName = "GridFourIcon";
const s = r;
export {
  s as GridFour,
  r as GridFourIcon
};
